import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { Countdown } from './Countdown';
import { closeRows } from '../data/tables';
import { CHECKOUT_URL } from '../config/launch';
export function Close() {
  return <section aria-labelledby="close-heading" className="w-full bg-forest text-white" data-id="element-46" data-mp="1q01dqad433q7">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-47" data-mp="1kzwyennxwf1k">
        <div className="mx-auto max-w-3xl text-center" data-id="element-48" data-mp="1l1zwzw35rghw">
          <h2 id="close-heading" className="font-serif text-3xl font-semibold leading-[1.12] text-white sm:text-[48px]" data-id="element-49" data-mp="1g8n8dlyhb9p5">
            Stop guessing with other people's bodies.
          </h2>

          <p className="mt-6 font-sans text-[17px] leading-[1.65] text-white/70 sm:text-lg" data-id="element-50" data-mp="17al8j9qhen3g">
            Right now, you pray nobody mentions an injury before class. With a protocol, you welcome
            the question — because you know exactly what to ask, what to avoid, what to teach
            instead, and when to refer out.
          </p>

          <p className="mt-8 font-sans text-[12px] font-semibold uppercase tracking-[0.14em] text-brass" data-id="element-51" data-mp="4199z9fvmyre">
            Screen · Flag · Adapt — 40+ conditions · Mat + Reformer · Scripts included
          </p>
        </div>

        <ul className="mx-auto mt-12 max-w-2xl divide-y divide-white/10 border-y border-white/10" data-id="element-52" data-mp="3qhddgg8ed4oc">
          {closeRows.map(([before, after]) => <li key={before} className="grid grid-cols-1 items-center gap-2 py-4 sm:grid-cols-[1fr_auto_1fr] sm:gap-4" data-id="element-53" data-mp="mzlicsyys4lx">
              <span className="font-sans text-[15px] text-white/45 line-through sm:text-right" data-id="element-54" data-mp="81t40455lm9b">
                {before}
              </span>
              <ArrowRightIcon className="hidden h-4 w-4 text-brass sm:block" strokeWidth={2} aria-hidden="true" data-id="element-55" data-mp="2ssjuonup5yks" />
              <span className="font-sans text-[15px] font-semibold text-white" data-id="element-56" data-mp="2xpjz6ubwet9s">{after}</span>
            </li>)}
        </ul>

        <div className="mt-12 text-center" data-id="element-57" data-mp="za2ytblbvckz">
          <p className="font-sans text-[15px] text-white/70" data-id="element-58" data-mp="zacrx81o5zuw">
            Screen &amp; Adapt™ — 6 Volumes + 5 Bonuses ·{' '}
            <span className="line-through text-white/40" data-id="element-59" data-mp="ugrsdbkfgxtl">$97</span>{' '}
            <span className="font-semibold text-brass" data-id="element-60" data-mp="pji4w1glmw8e">→ $27</span>
          </p>

          <div className="mt-8" data-id="element-61" data-mp="klzsg13dhyvn">
            <Countdown size="sm" data-id="element-62" data-mp="kiu4ip6hd31i" />
          </div>

          <div className="mt-10 flex flex-col items-center" data-id="element-63" data-mp="gj3i0xnzl92s">
            <CtaButton href={CHECKOUT_URL} size="xl" variant="brass-edge" data-id="element-64" data-mp="glpp6w6ytmkh">
              Yes, I want Screen &amp; Adapt™
            </CtaButton>
            <TrustRow tone="dark" className="mt-6 justify-center" data-id="element-65" data-mp="6m78qpq9kix6" />
          </div>
        </div>
      </div>
    </section>;
}